import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {withTranslation} from 'react-i18next';
import {mapToCssModules} from '../helpers/Utils';
import {required} from '../helpers/Validators';
import {Field} from 'react-final-form';
import {NotificationManager} from '../components/common/react-notifications';
import FieldError from './FieldError';
import ModalManager from "./modal/ModalManager";
import Zoom from "react-medium-image-zoom";

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  valid: PropTypes.bool,
  invalid: PropTypes.bool,
  bsSize: PropTypes.string,
  htmlFor: PropTypes.string,
  cssModule: PropTypes.object,
  onChange: PropTypes.func,
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func,
  ])
};

class FileField extends React.Component {
  defaultProps = {
    withoutPreview: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      fileName: null,
    };
  }

  onChange = (event, fieldInput) => {
    const file = event.target.files[0];
    const {t, item} = this.props;
    if (file) {
      if (file.type.includes("image")) {
        if (!item.accept.includes(file.type)) {
          if (item.accept === "image/png,image/jpeg") {
            NotificationManager.error(
              t('Image must be JPEG or PNG.'),
              t('Message')
            );
          }
          if (item.accept === "image/svg+xml") {
            NotificationManager.error(
              t('Image must be SVG.'),
              t('Message')
            );
          }
          return;
        }
        if (file.size > 1000000) {
          NotificationManager.error(t('File max size limit is 1mb'), t('Message'));
          return;
        }
      } else {
        if (!item.accept.includes(file.type)) {
          NotificationManager.error(
            t('Video must be MP4.'),
            t('Message')
          );
          return;
        }
        if (file.size > 20000000) {
          NotificationManager.error(t('File max size limit is 20mb'), t('Message'));
          return;
        }
      }

      const reader = new FileReader();
      reader.onload = e => {
        fieldInput.onChange(e.target.result);
      };
      reader.onerror = error => {
        console.log('error: ', error);
      };
      reader.readAsDataURL(file);
      this.setState({
        fileName: file.name,
      });
    } else {
      fieldInput.onChange(undefined);
      this.setState({
        fileName: null,
      });
    }
  };

  render() {
    const {
      t,
      className,
      label,
      valid,
      invalid,
      cssModule,
      innerRef,
      htmlFor,
      dataBrowse,
      item,
      ...attributes
    } = this.props;

    const customClass = mapToCssModules(
      classNames(
        className,
        'custom-file',
      ),
      cssModule
    );

    const validationClassNames = mapToCssModules(
      classNames(
        invalid && 'is-invalid',
        valid && 'is-valid',
      ),
      cssModule
    );

    const labelHtmlFor = htmlFor || attributes.id;

    return (
      <Field name={item.name} validate={item.required ? required : null}>
        {({input}) => {
          return (
            <div className="mb-2">
              <div>
                <div>
                  <span>{item.i18n}</span>
                  <span>{item.unit}</span>
                  {item.required ? <span className="required">*</span> : ''}
                </div>
                <div className={customClass}>
                  <input
                    {...attributes}
                    type="file"
                    ref={innerRef}
                    id="exampleCustomFileBrowser"
                    accept={item.accept}
                    disabled={item.disabled}
                    className={classNames(validationClassNames, mapToCssModules('custom-file-input', cssModule))}
                    onChange={e => {this.onChange(e, input);}}
                  />
                  <label
                    className={mapToCssModules('custom-file-label', cssModule)}
                    htmlFor={labelHtmlFor}
                    data-browse={dataBrowse}
                  >
                    {this.state.fileName || t('File Name')}
                  </label>
                </div>
              </div>
              {!item.withoutPreview && (input.value || item.path) ?
                <img
                  onClick={() => {
                    ModalManager.open({
                      size: 'lg',
                      isOpen: true,
                      title: item.i18n || item.name,
                      body: <Zoom><img src={input.value ? input.value : item.path} width="100%" height="100%"/></Zoom>,
                    });
                  }}
                  src={input.value ? input.value : item.path}
                  className="file-field-image mt-2"
                  height={item.previewSize || "400px"}
                  width={item.previewSize || "100%"}
                />
                :
                null
              }
              <FieldError name={item.name}/>
            </div>
          );
        }}
      </Field>
    );
  }
}

FileField.propTypes = propTypes;

export default withTranslation()(FileField);
